<template functional>
  <!-- eslint-disable -->
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12,3.25c-5.74,0-9.75,3.6-9.75,8.751a8.3,8.3,0,0,0,1.89,5.425,4.124,4.124,0,0,1-1.455,2.155,1.228,1.228,0,0,0,.749,2.162c.137.005.279.007.423.007a7.225,7.225,0,0,0,4.749-1.477,11.843,11.843,0,0,0,3.394.48c5.74,0,9.75-3.6,9.75-8.752S17.74,3.25,12,3.25Zm0,16a10.208,10.208,0,0,1-3.345-.539.749.749,0,0,0-.792.2,5.326,5.326,0,0,1-3.679,1.333,5.391,5.391,0,0,0,1.507-2.914A.749.749,0,0,0,5.5,16.7,6.787,6.787,0,0,1,3.75,12C3.75,7.732,7.143,4.75,12,4.75S20.25,7.732,20.25,12,16.857,19.253,12,19.253ZM15.279,7.73a1.623,1.623,0,0,0-1.158-.48h0a1.625,1.625,0,0,0-1.158.482L7.469,13.249a.745.745,0,0,0-.219.529V16a.75.75,0,0,0,.75.75h2.223a.755.755,0,0,0,.529-.218l5.516-5.491a1.64,1.64,0,0,0,0-2.321ZM14.12,8.75h0a.137.137,0,0,1,.1.041l.99.99a.138.138,0,0,1,.041.1.136.136,0,0,1-.041.1l-.636.633L13.389,9.427l.634-.636A.135.135,0,0,1,14.12,8.75Zm-4.207,6.5H8.75V14.087l3.581-3.6,1.179,1.179Z" />
  </svg>
</template>

<script>
export default {
  name: 'IconNewTask',
};
</script>